import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  resetProjectsState: async ({ commit }) => {
    commit('resetState');
  },

  getProjects: async ({ commit }, payload) => {
    try {
      const res = await axios.get(`/projects`, {
        params: {
          ...payload
        }
      });

      commit('mutateProjects', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProjectGroups: async ({ commit }, payload) => {
    try {
      const { projectId, ...theRest } = payload;

      const res = await axios.get(
        `/projects/${projectId}/project-groups`,
        {
          params: {
            ...theRest
          }
        }
      );

      commit('mutateProjectGroups', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProjectsToDo: async ({ commit }) => {
    const data = [
      {
        projectName: 'Breads of the Creative Cities',
        projectImageSrc:
          'https://bcassetcdn.com/asset/logo/63c9d9f6-f4c5-489f-9b61-91f9fb3dda78/logo?v=4&text=Logo+Text+Here',
        toDo: [
          {
            toDoItem: 'About Us',
            incompleteFields: [
              'First Name',
              'Last Name',
              'Address',
              'Company Logo'
            ],
            numberOfFields: 4
          },
          {
            toDoItem: 'Supply Chain Item',
            incompleteFields: ['Name', 'Description'],
            numberOfFields: 2
          },
          {
            toDoItem: 'Recipe',
            incompleteFields: ['Name', 'Description', 'Ingredients', 'Image'],
            numberOfFields: 4
          }
        ]
      },
      {
        projectName: 'Ranchers And Farmers',
        projectImageSrc:
          'https://image.freepik.com/free-vector/cow-farm-logo_42174-13.jpg',
        toDo: [
          {
            toDoItem: 'About Us',
            incompleteFields: [
              'First Name',
              'Last Name',
              'Address',
              'Company Logo'
            ],
            numberOfFields: 4
          },
          {
            toDoItem: 'Supply Chain Item',
            incompleteFields: ['Name', 'Description'],
            numberOfFields: 2
          },
          {
            toDoItem: 'Supply Chain Item #2',
            incompleteFields: ['Name', 'Description'],
            numberOfFields: 2
          },
          {
            toDoItem: 'Recipe',
            incompleteFields: ['Name', 'Description', 'Ingredients', 'Image'],
            numberOfFields: 4
          }
        ]
      }
    ];

    commit('mutateProjectsToDo', data);
  },

  getProjectMembers: async ({ commit }, payload) => {
    const { projectId, ...params } = payload;

    const res = await axios.get(
      `/projects/${projectId}/members`,
      {
        params: {
          ...params
        }
      }
    );

    commit('mutateMembersOfSelectedProject', res.data);

    return res;
  },

  getProjectDocuments: async ({ commit }, payload) => {
    const { projectId, ...params } = payload;

    const res = await axios.get(
      `/projects/${projectId}/documents`,
      {
        params: {
          ...params
        }
      }
    );

    commit('mutateDocumentsOfSelectedProject', res.data);

    return res;
  },

  getProjectById: async ({ commit }, payload) => {
    try {
      commit('mutateProjectIdError', '');
      const { projectId } = payload;
      const res = await axios.get(`/projects/${projectId}`);
      commit('mutateProjectById', res.data);
    } catch (e) {
      commit('mutateProjectIdError', 'There was an error fetching the project');
    }
  },

  getAllProjectKinds: async ({ commit }, payload) => {
    const { projectId } = payload;

    const res = await axios.get(
      `/projects/${projectId}/kinds`
    );

    commit('mutateAllProjectKinds', res.data);
  },

  getProjectRoles: async ({ commit }, payload) => {
    const { projectId } = payload;

    const res = await axios.get(
      `/projects/${projectId}/composed-bys`
    );
    commit('mutateProjectRoles', res.data);

    return res;
  },

  postNewProject: async (_, payload) => {
    try {
      const res = await axios.post(`/projects`, payload);

      return res;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  updateProject: async (_, payload) => {
    const { projectId, ...theRest } = payload;

    try {
      const res = await axios.put(
        `/projects/${projectId}`,
        theRest
      );

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  deleteProject: async (_, payload) => {
    try {
      const { projectId } = payload;

      const res = await axios.delete(
        `/projects/${projectId}`
      );
      return res.status;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  postProjectLeader: async (_, payload) => {
    const { projectId, profileId } = payload;

    try {
      const res = await axios.post(
        `/projects/${projectId}/leader?profileId=${profileId}`
      );

      return res;
    } catch (err) {
      console.error(err);
      return;
    }
  },

  getProjectMembersForSearching: async (_, payload) => {
    const { projectId, ...params } = payload;

    const res = await axios.get(
      `/projects/${projectId}/members`,
      {
        params: {
          ...params
        }
      }
    );

    return res;
  },

  getProjectItineraries: async ({ commit }, payload) => {
    try {
      const { projectId, ...params } = payload;

      const res = await axios.get(
        `/projects/${projectId}/itineraries`,
        {
          params: { ...params }
        }
      );

      commit('mutateProjectItineraries', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getNotImpersonatedMembers: async ({ commit }, payload) => {
    try {
      const { projectId, ...params } = payload;

      const res = await axios.get(
        `/projects/${projectId}/members/not-impersonated`,
        {
          params: { ...params }
        }
      );

      commit('mutateProjectMembersNotImpersonated', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProjectTabs: async ({ commit }, payload) => {
    try {
      const { projectId } = payload;

      const res = await axios.get(
        `/projects/${projectId}/tab-counters`
      );

      commit('mutateProjectTabs', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getProjectsForFilters: async ({ commit }, payload) => {
    try {
      const res = await axios.get(
        `/projects/browse-projects`,
        {
          params: {
            ...payload
          }
        }
      );

      commit('mutateProjectsForFilter', res.data);
      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
};

export const mutations = {
  resetState: state => {
    Object.assign(state, initialState());
  },

  mutateProjects: (state, payload) => {
    state.projects = payload;
  },

  mutateProjectsForFilter: (state, payload) => {
    const projectList = [{ text: 'View All Projects', value: '' }];
    const projects = payload.list.map(({ project }) => ({
      text: project.name,
      value: project.projectId.replace('#', '')
    }));

    projectList.push(...projects);

    state.projectFilters = projectList;
  },

  mutateProjectGroups: (state, payload) => {
    state.projectGroups = payload;
  },

  mutateProjectsToDo: (state, payload) => {
    state.kkProjects = payload;
  },

  mutateMembersOfSelectedProject: (state, payload) => {
    state.membersOfSelectedProject = payload;
  },

  mutateDocumentsOfSelectedProject: (state, payload) => {
    state.documentsOfSelectedProject = payload;
  },

  mutateProjectById: (state, payload) => {
    state.projectById = payload;
  },

  mutateProjectIdError: (state, payload) => {
    state.projectIdError = payload;
  },

  mutateAllProjectKinds: (state, payload) => {
    state.allProjectKinds = payload;
  },

  mutateProjectRoles: (state, payload) => {
    //Filter internal system role
    const filteredProjectRoles = payload.filter(role => {
      return role.composedBy.role.toLowerCase() !== 'system';
    });

    state.projectRoles = filteredProjectRoles;
  },

  mutateMemberInSelectedProject: (state, payload) => {
    const { memberOfId, memberOf, profileId } = payload;

    const indexOfMember = state.membersOfSelectedProject.list.findIndex(
      member => {
        return member.profile.profileId === profileId;
      }
    );

    const indexOfMemberOf = state.membersOfSelectedProject.list[
      indexOfMember
    ].memberOfs.findIndex(
      memberOf => memberOf.memberOf.memberOfId === memberOfId
    );

    state.membersOfSelectedProject.list[indexOfMember].memberOfs[
      indexOfMemberOf
    ].memberOf = memberOf;
  },

  mutateProjectItineraries: (state, payload) => {
    state.projectItineraries = payload;
  },

  mutateProjectMembersNotImpersonated: (state, payload) => {
    state.membersNotImpersonated = payload;
  },

  mutateProjectTabs: (state, payload) => {
    state.projectTabs = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    projects: [],
    projectGroups: [],
    documentsOfSelectedProject: [],
    kkProjects: [],
    membersOfSelectedProject: [],
    projectById: {},
    projectIdError: '',
    allProjectKinds: [],
    projectRoles: [],
    projectItineraries: {},
    membersNotImpersonated: {},
    projectTabs: {},
    projectFilters: []
  };
}
